// A staging build may opt into the existing Build route tree on one exact hostname.
// Production's host stays supported; this does not alter authentication or permissions.
export function isBuildHost(hostname, stagingHost = process.env.REACT_APP_BUILD_HOST) {
  return hostname === "build.njmpro.com" || Boolean(stagingHost && hostname === stagingHost);
}
